import { Imagen } from "../interfaces/imagen";
import Banner from "../media/img/home/banner/banner (1).jpg";
import Banner001 from "../media/img/home/banner.png";
import BannerVid from "../media/img/home/banner.mp4";
import BannerVideo from "../media/img/home/banner.gif";

export const MockBanners: Imagen[] = 
[
    {
        id: 1,
        titulo: '',
        subtitulo: '',
        descripcion: '',
        imagenUrl: Banner,
        tipoSeccion: {
            id: 1,
            descripcion: 'Banner'
        }
    }
]